<div class="tab-content">
  <div
    *ngFor="let certificate of certifications; trackBy: track"
    class="item"
  >
    <h5>{{ certificate?.name | mojoHighlight: keywords }}</h5>

    <dl class="row">
      <dt class="col-md-2">Description:</dt>
      <dd class="col-md-10">
        {{ certificate?.description | mojoHighlight: keywords }}</dd>

      <dt
        *ngIf="certificate?.firstIssuedDate"
        class="col-md-2"
      >Issue date:</dt>
      <dd
        *ngIf="certificate?.firstIssuedDate"
        class="col-md-10"
      >
        {{ certificate?.firstIssuedDate | daysPassed: true }}</dd>
    </dl>
  </div>
</div>
